var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{staticStyle:{"height":"100vh"},attrs:{"src":_vm.src,"frameborder":"0","width":"100%"}})}
var staticRenderFns = []

export { render, staticRenderFns }